<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="hiringModalities"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Modalidades da Contratação"
        label-for="hiringModalities"
      >
        <v-select
          id="hiringModalities"
          v-model="hiringModalities"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="nome"
          :options="dataOptions"
          :placeholder="'Modalidades da Contratação'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ nome }">
            <span>{{ nome }}</span>
          </template>

          <template #selected-option="{ nome }">
            <span>{{ nome | truncate(truncateField, '...') }}</span>
          </template>

          <template #no-options>
            Não há opções de empresas.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import truncate from '@/components/utils/filters/truncate'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'hiringModalitiesValue',
    event: 'hiringModalitiesChange',
  },
  props: {
    hiringModalitiesValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    truncateField: {
      type: Number,
      required: false,
      default: 17,
    },
  },
  data() {
    const dataOptions = []
    const newHiringModalitiesValue = this.hiringModalitiesValue

    return {
      dataOptions,
      newHiringModalitiesValue,
      required,
    }
  },
  computed: {
    hiringModalities: {
      get() {
        return this.newHiringModalitiesValue
      },
      set(value) {
        this.newHiringModalitiesValue = value
        this.$emit('hiringModalitiesChange', this.newHiringModalitiesValue)
      },
    },
  },
  watch: {
    hiringModalitiesValue(newVal) {
      this.newHiringModalitiesValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .pncp
        .hiringModalitie
        .fetchHiringModalities()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['nome'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
